__turbopack_context__.v({
  "slideOffer": "styles-module__kn8LQq__slideOffer",
});
